module.exports = __webpack_public_path__ + "static/api-reference-img-6620538a7e713e8914f51780e4fd3881.png";